import styled from 'styled-components';

import { global } from '../../../../shared/colors';

const StyledDownload = styled.a`
    width: 32px;
    height: 32px;
    display: grid;
    place-items: center;
    color: ${global.Gray3};
    margin-left: 80px;
    margin-top: 36px;
    z-index: 10;

    &:hover {
        background: ${global.Gray4};
        color: ${global.Black};
        border-radius: 5px;
    }
`;

export default StyledDownload;
